import Swal from 'sweetalert2'

const swalWithBootstrapButtons = Swal.mixin({
  customClass: {
      confirmButton: 'btn btn-success',
      cancelButton: 'btn btn-danger'
  },
      buttonsStyling: true
  })

const showMessageError = (message) => {
    Swal.fire({
      type: 'error',
      title: message,
      text: 'Try again !',
      allowOutsideClick: false
    })
  }


 const showMessageSuccess = (title, message) => {
    swalWithBootstrapButtons.fire(title,message,'success')
 }
  const showMessageWarning = (title, message) => {
    Swal.fire({
      title: title,
      text:  message,
      type: "warning",
      allowOutsideClick: false
    })
  }

export { showMessageError, showMessageSuccess, showMessageWarning }